module.exports = __webpack_public_path__ + "static/media/arya_kulkarnia8.29e3e1ce.png";